<template>
  <div class="bg-more">
    <section class="contact bg-light py-5">
      <div class="container-Contact">
        <el-row :gutter="20">
          <!-- 侧边栏 -->
          <el-col :span="24" :sm="4">
            <div class="select-box">
              <el-input
                class="w100 mb-1"
                :placeholder="$t('wines.inputplaceholder1')"
                v-model="wine_name"
                size="mini"
                @change="handleCheckshareList(1)"
              >
                <el-button slot="append" type="primary" icon="el-icon-search" @click="handleCheckshareList(1)"></el-button>
              </el-input>
              <el-input
                class="w100 mb-1"
                :placeholder="$t('wines.inputplaceholder2')"
                v-model="priceTemplate[0].search"
                clearable
                size="mini"
                @keyup.enter.native="handleCheckshareList(1)"
              >
              </el-input>
              <el-input
                class="w100 mb-1"
                :placeholder="$t('wines.inputplaceholder3')"
                v-model="priceTemplate[1].search"
                clearable
                size="mini"
                @keyup.enter.native="handleCheckshareList(1)"
              >
              </el-input>
              <el-select class="w100 mb-1" v-model="selectType" placeholder="请选择筛选类型" size="mini" @change="handleFiliterChange">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <div class="checkbox p-1" v-loading="isLoading">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ $t("wines.allIn") }}</el-checkbox>
                <el-checkbox-group text-color="#FFB800" v-model="checkedfiliter" @change="handleCheckedfiliterChange">
                  <el-checkbox v-for="city in filiter" :label="city" :key="city">{{ city }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-col>

          <!-- 主内容 -->
          <el-col :span="24" :sm="20">
            <el-main>
              <div class="select-table">
                <el-table :data="tableData" border style="width: 100%" height="750" v-loading="isLoading">
                  <el-table-column prop="wine_ch" :label="$t('wines.tableFormat.chFormat')" min-width="200" align="left"> </el-table-column>
                  <el-table-column prop="wine_en" :label="$t('wines.tableFormat.enFormat')" min-width="200" align="left"> </el-table-column>
                  <el-table-column prop="ljx_wine_year" :label="$t('wines.tableFormat.yearFormat')" width="80" align="center"> </el-table-column>
                  <el-table-column prop="ljx_style" :label="$t('wines.tableFormat.typeFormat')" width="80" align="center"> </el-table-column>
                  <el-table-column prop="ljx_size" :label="$t('wines.tableFormat.specificationsFormat')" width="80" align="center"> </el-table-column>
                  <el-table-column prop="ljx_country" :label="$t('wines.tableFormat.countryFormat')" width="80" align="center"> </el-table-column>
                  <el-table-column prop="ljx_regions" :label="$t('wines.tableFormat.areaFormat')" width="100" align="center"> </el-table-column>
                  <el-table-column prop="group_price" :label="$t('wines.tableFormat.priceFormat')" width="100" align="center">
                    <template slot-scope="scope"> {{ scope.row.sys_mbol }}&nbsp;&nbsp;{{ scope.row.group_price }} </template>
                  </el-table-column>
                </el-table>
                <el-row class="row-pagination mt-1">
                  <el-pagination
                    :current-page="searchForm.page"
                    :page-size="searchForm.per_page"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.total"
                    @size-change="handleSizeChange"
                    @current-change="handlePageNoChange"
                  />
                </el-row>
              </div>
            </el-main>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkAll: false,
      checkedfiliter: [],
      filiter: [],
      isIndeterminate: true,
      isLoading: false,
      searchForm: { total: 0, page: 1, per_page: 50 },
      wine_name: "",
      fieldList: [],
      options: [],
      tableData: [],
      selectType: "ljx_wine_year",
      priceTemplate: [
        {
          condition: ">=",
          connect: "and",
          field: "em_goods_price.group_price",
          left: "(",
          right: "",
          search: "",
        },
        {
          condition: "<=",
          connect: "and",
          field: "em_goods_price.group_price",
          left: "",
          right: ")",
          search: "",
        },
      ],
      forEachTemplate: {
        ljx_wine_year: { left: "", field: "em_goods.ljx_wine_year", condition: "=", search: "", right: "", connect: "or" },
        ljx_country: { left: "", field: "em_goods.ljx_country", condition: "=", search: "", right: "", connect: "or" },
        ljx_regions: { left: "", field: "em_goods.ljx_regions", condition: "=", search: "", right: "", connect: "or" },
        ljx_style: { left: "", field: "em_goods.ljx_style", condition: "=", search: "", right: "", connect: "or" },
        ljx_size: { left: "", field: "em_goods.ljx_size", condition: "=", search: "", right: "", connect: "or" },
      },
    };
  },
  created() {
    this.handleFiliterChange();
  },
  mounted() {
    this.updateOptions(); // 初始化时设置 options
  },
  watch: {
    "$i18n.locale": "updateOptions",
  },
  methods: {
    updateOptions() {
      this.options = [
        { label: this.$t("wines.filterOptions.yearFormat"), value: "ljx_wine_year" },
        { label: this.$t("wines.filterOptions.countryFormat"), value: "ljx_country" },
        { label: this.$t("wines.filterOptions.areaFormat"), value: "ljx_regions" },
        { label: this.$t("wines.filterOptions.specificationsFormat"), value: "ljx_size" },
        { label: this.$t("wines.filterOptions.typeFormat"), value: "ljx_style" },
      ];
    },
    contactSubmit() {
      $("#contactModal").modal("show");
      setTimeout(() => {
        $("#contactModal").modal("hide");
      }, 5000);
    },
    /** 查询当前过滤信息 */
    handleFiliterChange() {
      this.isLoading = true;
      this.checkedfiliter = [];
      this.checkAll = false;
      this.fieldList = [];
      const url = `${process.env.VUE_APP_APIPATH}/shop/v2/stock/shareGetProperty`;
      this.$http
        .post(url, { type: this.selectType, shop_ids: [9] }) //力发的数据
        .then((res) => {
          const dataList = res?.data?.result;
          this.filiter = dataList;
          this.isLoading = false;
          this.handleCheckshareList();
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    /** 查询列表信息 */
    handleCheckshareList(page = 1) {
      this.isLoading = true;
      const url = `${process.env.VUE_APP_APIPATH}/shop/v2/stock/shareList`;
      this.searchForm.page = page;
      this.$http
        .post(url, {
          plan_field: [
            { condition: "like", connect: "and", field: "em_goods.goods_name", left: "", right: "", search: this.wine_name },
            ...this.fieldList,
            ...this.priceTemplate,
          ],
          shop_ids: [9],
          ...this.searchForm,
        }) //龙酒轩的数据
        .then((res) => {
          const { list: dataList } = res?.data?.result;
          this.searchForm.total = dataList?.total;
          this.tableData = dataList?.data;

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },

    /**全选数据 */
    handleCheckAllChange(val) {
      this.checkedfiliter = val ? this.filiter : [];
      this.isIndeterminate = false;
      this.changeAllmoelTemp();
      this.handleCheckshareList(1); // 重新查询列表数据
    },
    /** 处理模板字段发送后端 */
    changeAllmoelTemp() {
      const eachTemplate = this.forEachTemplate[this.selectType];
      // 清空 fieldList，以避免旧数据干扰
      this.fieldList = [];
      this.checkedfiliter.forEach((val, index) => {
        // 每次循环都复制一份 eachTemplate，避免引用问题
        const templateCopy = { ...eachTemplate };

        // 判断第一个元素，给 left 赋值为 '('
        if (index === 0) {
          templateCopy.left = "(";
        } else {
          templateCopy.left = ""; // 其他元素清空 left
        }

        // 判断最后一个元素，给 right 赋值为 ')'
        if (index === this.checkedfiliter.length - 1) {
          templateCopy.right = ")";
          templateCopy.connect = "and";
        } else {
          templateCopy.right = ""; // 其他元素清空 right
        }

        // 设置 search 为当前的值
        templateCopy.search = val;

        // 推入到 fieldList
        this.fieldList.push(templateCopy);
      });
    },
    /**单选数据 */
    handleCheckedfiliterChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.filiter.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.filiter.length;
      this.changeAllmoelTemp();
      this.handleCheckshareList(1); // 重新查询列表数据
    },
    // 页码切换
    handleSizeChange(per_page = 20) {
      this.searchForm.per_page = per_page;
      this.handleCheckshareList(this.searchForm.page);
    },
    // 页数切换
    handlePageNoChange(page = 1) {
      this.handleCheckshareList(page);
    },
  },
};
</script>
<style scoped>
.row-pagination {
  display: flex;
  justify-content: flex-end;
}
.w100 {
  width: 100%;
}
.container-Contact {
  width: 80%;
}
.contact {
  background: url("../../assets/img/container_bg.png") no-repeat;
  background-size: cover;
}
.select-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 5px;
}
.checkbox {
  background: #f6f6f6;
  border: 1px solid #e3e3e3;
  width: 100%;
  height: 625px;
  border-radius: 5px;
  overflow: hidden scroll;
}
.el-main {
  padding: 0 20px;
}
@media (max-width: 768px) {
  .el-main {
    padding: 0 !important;
  }
  .checkbox {
    height: 150px;
  }
  .container-Contact {
    width: 94%;
  }
  .el-table {
    height: 600px !important;
  }
}

/deep/ .is-checked::after {
  background-color: #ffb800;
}
/deep/ .is-focus::after {
  background-color: #ffb800;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ffb800;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.myRedCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #ffb800;
}
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #ffb800;
}
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffb800;
  border-color: #ffb800;
}
/* 隐藏 Chrome 和 Safari 的滚动条 */
::-webkit-scrollbar {
  display: none;
}
</style>
